




























































































import { ApplicablePoint } from '@/models/point/applicable-point'
import { ConditionToApplyPoint } from '@/models/point/condition-to-apply-point'
import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

import { formatPrice } from '@/util/format'
import SpaAcordionLike from '@spa/components/atoms/transition/AcordionLike.vue'
import InputApplyingPoint from '@spa/components/organisms/order/point/InputApplyingPoint.vue'

@Component({
  components: {
    InputApplyingPoint,
    SpaAcordionLike,
  },
})
export default class ApplyPoint extends Vue {
  @Prop({ required: true })
  /**
   * 適用済みポイント
   */
  readonly value: number

  @Prop({ required: true })
  /**
   * ポイント適用による割引額
   */
  readonly discountPrice: number

  @Prop({ required: true })
  readonly condition: ConditionToApplyPoint

  @Prop({ required: true })
  readonly applicablePoint: ApplicablePoint

  @Prop({ default: false })
  readonly loading: boolean

  isAccordionOpen = false

  get hasApplicablePoint(): boolean {
    return this.applicablePoint.exists
  }

  get shouldDisplayDiscountPrice(): boolean {
    return this.discountPrice > 0
  }

  get formattedDiscountPrice(): string {
    return formatPrice(this.discountPrice * -1)
  }

  // アコーディオンの開閉切り替え.
  onToggleAccordion() {
    this.isAccordionOpen = !this.isAccordionOpen
  }

  @Emit()
  apply(_applied: number): void {
    // nothing to do
  }

  @Emit()
  input(): void {
    // nothing to do
  }
}
